module.exports = __webpack_public_path__ + "80444afea12a1ed1c63a359730d9daa7.png";